import {
  YOTI,
  POST_OFFICE,
  YOTI_WITH_POST_OFFICE,
  DIDC
} from './skins-identifiers'
import {
  YOTI_APP,
  EASYID_APP,
  SMART_ID_APP
} from './apps-identifiers'

const yotiApp = {
  id: YOTI_APP,
  name: 'Yoti app'
}

const easyidApp = {
  id: EASYID_APP,
  name: 'Post Office EasyID'
}

const smartidApp = {
  id: SMART_ID_APP,
  name: 'Lloyds Smart ID'
}

const appsBySkinId = {
  [YOTI]: [yotiApp],
  [POST_OFFICE]: [easyidApp],
  [YOTI_WITH_POST_OFFICE]: [easyidApp, yotiApp],
  [DIDC]: [easyidApp, yotiApp, smartidApp]
}


export const getSupportedApps = skinId => (appsBySkinId[skinId] || [])
